<script>

import config from '../../common/genericPanelConf';
import GenericDataTable from '@/components/generic/GenericDataTable.vue';
import TheoreticalLotsGrid from '@/components/planning/TheoreticalLotsGrid.vue';
import SchedulingImplementationAttachments from '@/components/operative-plan/SchedulingImplementationAttachments.vue';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable, TheoreticalLotsGrid, SchedulingImplementationAttachments
    },
    data(){
        return{
            configuration: null,
            theoreticalLotsDialogVisible: false,
            schedulingImplementationAttachmentsVisible: false,
            schedulingImplementationAttachmentsId: null
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        onAdd(){
            let uri = `/${this.category}/${this.name}/0`;
            this.$router.push(uri);
        },
        showTheoreticalLotsDialog(){
            this.theoreticalLotsDialogVisible = true;
        },
        showSchedulingAttachmentsDialog(record){
            console.log(record)
            this.schedulingImplementationAttachmentsId = record.id;
            this.schedulingImplementationAttachmentsVisible = true;
        }
    },
    computed: {
        conf(){
            return config;
        }
    }
}
</script>



<template>
    <Dialog v-model:visible="schedulingImplementationAttachmentsVisible" modal :style="{ width: '85vw'}">
        <SchedulingImplementationAttachments :id="schedulingImplementationAttachmentsId" />
    </Dialog>
    <Dialog v-model:visible="theoreticalLotsDialogVisible" modal :style="{ width: '85vw'}">
        <TheoreticalLotsGrid :showCreate="true" :showLink="false"/>
    </Dialog>
    <div class="" style="height: 80vh;">
        <GenericDataTable :configuration="configuration" :category="category" :name="name" @on-show-theoretical-lots-dialog="showTheoreticalLotsDialog" @showSchedulingAttachmentsDialog="showSchedulingAttachmentsDialog"/>
    </div>
</template>